import request from '@/utils/request'
import type { AxiosPromise } from 'axios'
import type { Notification } from '@/types/notification'

export interface NotificationListParams {
  page?: number
  size?: number
}

export interface NotificationListResponse {
  list: Notification[]
  total: number
  page: number
  size: number
}

export interface UnreadCountResponse {
  count: number
}

export interface MarkReadResponse {
  affected: number
}

// Get notification list
export function getNotifications(params: NotificationListParams): AxiosPromise<{
  code: number
  data: NotificationListResponse
  message: string
}> {
  return request({
    url: '/notifications/list',
    method: 'post',
    data: params
  })
}

// Get unread count
export function getUnreadCount(): AxiosPromise<{
  code: number
  data: UnreadCountResponse
  message: string
}> {
  return request({
    url: '/notifications/unread-count',
    method: 'post'
  })
}

// Mark notification as read
export function markAsRead(id: number): AxiosPromise<{
  code: number
  data: Record<string, never>
  message: string
}> {
  return request({
    url: `/notifications/mark-read/${id}`,
    method: 'post'
  })
}

// Mark all notifications as read
export function markAllAsRead(): AxiosPromise<{
  code: number
  data: MarkReadResponse
  message: string
}> {
  return request({
    url: '/notifications/mark-all-read',
    method: 'post'
  })
}
